import React, { Fragment } from 'react';
import MaskedInput from 'react-input-mask';
import classNames from 'classnames';
import Spinner from '../Spinner/Spinner';
import styles from './Input.scss';
import SpinnerStyles from '../Spinner/Spinner.scss';
import Check from '../../../img/check.svg';
import Valid from '../../../img/ic-ok.svg';
import CaretDown from '../../../img/caretDown.svg';

const Input = props => {
  const renderErrorDescription = (errorBellowDescription, error, description) => {
    if (errorBellowDescription) {
      const ValidatorDescription =
        props.adaptive && description ? styles.ValidatorDescription : '';
      const ErrorBelowDescription =
        props.adaptive && props.error
          ? styles.ErrorBelowDescription
          : styles.EmptyErrorBelowDescription;
      const descriptionHide =
        props.descriptionHide && description && props.error
          ? styles.DescriptionHide
          : '';

      return (
        <React.Fragment>
          {<div className={classNames(ErrorBelowDescription)}>{error}</div>}
          {
            <div className={classNames(ValidatorDescription, descriptionHide)}>
              {description}
            </div>
          }
        </React.Fragment>
      );
    }

    const adaptiveDescriptionError =
      props.adaptive && props.error
        ? styles.ErrorDescription
        : props.adaptive
        ? styles.EmptyDescription
        : '';
    const adaptiveIframe =
      props.adaptiveIframe && props.error
        ? styles.ErrorForIframe
        : props.adaptiveIframe
        ? styles.EmptyErrorForIframe
        : '';
    const highInput =
      props.highInput && props.error
        ? styles.ErrorDefault
        : props.highInput
        ? styles.DescriptionDefault
        : '';
    const subText = description ? styles.SubText : '';
    const errorText = props.error ? styles.ErrorText : '';
    const simpleInput =
      props.simpleInput && props.error ? styles.ErrorText : '';
    const inputWithDescription =
      props.inputWithDescription && props.error && description
        ? styles.GeneralErrorText
        : '';
    const inputWithoutDescription =
      props.inputWithoutDescription && props.error && description
        ? styles.InputWithoutDescription
        : '';
    const inputWithLowIndentAfterDescription =
      props.inputWithLowIndentAfterDescription && description
        ? styles.InputWithLowIndentAfterDescription
        : '';

    return (
      <div
        className={classNames(
          adaptiveDescriptionError,
          adaptiveIframe,
          subText,
          errorText,
          simpleInput,
          highInput,
          inputWithDescription,
          inputWithoutDescription,
          inputWithLowIndentAfterDescription
        )}
      >
        {error || description}
      </div>
    );
  };

  const renderWithoutMask = () => {
    const {
      errorBellowDescription,
      btnOnClick,
      btnDisabled,
      disabled,
      name,
      value,
      defaultValue,
      type,
      onChange,
      onKeyPress,
      onFocus,
      onBlur,
      label,
      id,
      error,
      autofocus,
      checkEnable,
      isLoading,
      description,
      arrowButton,
      hint,
      autoComplete,
    } = props;
    const styleError = error && styles.Error;
    const adaptiveInput = props.adaptive && styles.AdaptiveInput;
    const adaptiveIframeInput =
      props.adaptiveIframe && styles.AdaptiveIframeInput;
    const highInput = props.highInput && styles.HighInput;
    const disabledInput = props.disabledInputStyle && styles.Disabled;
    const simpleInput = props.simpleInput && styles.SimpleInput;
    const inputWithDescription =
      props.inputWithDescription && styles.InputWithDescription;
    const inputWithoutDescription =
      props.inputWithoutDescription && styles.InputWithoutDescription;
    const inputWithLowIndentAfterDescription =
      props.inputWithLowIndentAfterDescription &&
      styles.InputWithLowIndentAfterDescription;

    return (
      <div className={styles.Relative}>
        <input
          data-test-id={props.testId || props['data-test-id']}
          className={classNames(
            styles.Input,
            styleError,
            adaptiveInput,
            adaptiveIframeInput,
            highInput,
            disabledInput,
            simpleInput,
            inputWithDescription,
            inputWithoutDescription,
            inputWithLowIndentAfterDescription,
            props.className
          )}
          name={name}
          onChange={onChange}
          value={value ? value : defaultValue}
          disabled={disabled}
          id={id}
          onKeyPress={onKeyPress}
          type={type}
          onFocus={onFocus}
          onBlur={onBlur}
          autoComplete={autoComplete || 'off'}
          autoFocus={autofocus}
          ref={props.inputRef}
        />
        <label className={value ? styles.Dirty : ''} htmlFor={id}>
          {label}
        </label>
        {type === 'dropdown' && (
          <div className={styles.Area}>
            <CaretDown className={styles.CaretDown}/>
          </div>
        )}
        {name === 'sendToEmail' && (
          <div
            className={btnDisabled ? styles.DisabledButton : styles.Button}
            onClick={btnOnClick}
          >
            →
          </div>
        )}
        {arrowButton && !isLoading && (
          <div
            data-test-id="sendToEmail"
            className={btnDisabled ? styles.DisabledButton : styles.Button}
            onClick={btnOnClick}
          >
            →
          </div>
        )}
        {value && !error && checkEnable ? (
          <Check className={styles.Check}/>
        ) : (
          ''
        )}
        {isLoading && (
          <div className={styles.WrapperSpinner}>
            <Spinner
              className={classNames(
                SpinnerStyles.SmallLoader,
                SpinnerStyles.TurquoiseColor
              )}
              IEStyle={SpinnerStyles.SmallLoaderIE}
            />
          </div>
        )}
        {props.check && (
          <div className={styles.Absolute}>
            <Valid/>
          </div>
        )}
        {renderErrorDescription(
          errorBellowDescription,
          error,
          description || hint
        )}
      </div>
    );
  };

  const renderWithMask = () => {
    const {
      errorBellowDescription,
      btnOnClick,
      btnDisabled,
      disabled,
      name,
      value,
      onChange,
      onKeyPress,
      onFocus,
      onBlur,
      mask,
      maskChar,
      formatChars,
      label,
      id,
      error,
      autofocus,
      checkEnable,
      isLoading,
      description,
      arrowButton,
      hint,
      autoComplete,
      type
    } = props;
    const styleError = error && styles.Error;
    const adaptiveInput = props.adaptive && styles.AdaptiveInput;
    const adaptiveIframeInput =
      props.adaptiveIframe && styles.AdaptiveIframeInput;
    const highInput = props.highInput && styles.HighInput;
    const disabledInput =
      disabled && adaptiveInput ? styles.adaptiveDisabled : '';
    const simpleInput = props.simpleInput && styles.SimpleInput;
    const inputWithDescription =
      props.inputWithDescription && styles.InputWithDescription;
    const inputWithoutDescription =
      props.inputWithoutDescription && styles.InputWithoutDescription;
    const inputWithLowIndentAfterDescription =
      props.inputWithLowIndentAfterDescription &&
      styles.InputWithLowIndentAfterDescription;

    return (
      <div className={styles.Relative}>
        <MaskedInput
          data-test-id={props.testId || props['data-test-id']}
          ref={props.inputRef}
          className={classNames(
            styles.Input,
            styleError,
            adaptiveInput,
            adaptiveIframeInput,
            highInput,
            disabledInput,
            simpleInput,
            inputWithDescription,
            inputWithoutDescription,
            inputWithLowIndentAfterDescription,
            props.className
          )}
          name={name}
          onChange={onChange}
          value={value}
          mask={mask}
          formatChars={formatChars}
          maskChar={maskChar}
          disabled={disabled}
          id={id}
          onKeyPress={onKeyPress}
          type={type}
          onFocus={onFocus}
          onBlur={onBlur}
          autoComplete={autoComplete || 'off'}
          autoFocus={autofocus}
        />
        <label className={value ? styles.Dirty : ''} htmlFor={id}>
          {label}
        </label>
        {name === 'sendToEmail' && (
          <div
            className={btnDisabled ? styles.DisabledButton : styles.Button}
            onClick={btnOnClick}
          >
            →
          </div>
        )}
        {arrowButton && !isLoading && (
          <div
            className={btnDisabled ? styles.DisabledButton : styles.Button}
            onClick={btnOnClick}
          >
            →
          </div>
        )}
        {value && !error && checkEnable ? (
          <Check className={styles.Check}/>
        ) : (
          ''
        )}
        {isLoading && (
          <div className={styles.WrapperSpinner}>
            <Spinner
              className={classNames(
                SpinnerStyles.SmallLoader,
                SpinnerStyles.TurquoiseColor
              )}
              IEStyle={SpinnerStyles.SmallLoaderIE}
            />
          </div>
        )}
        {props.check && (
          <div className={styles.Absolute}>
            <Valid/>
          </div>
        )}
        {renderErrorDescription(
          errorBellowDescription,
          error,
          description || hint
        )}
      </div>
    );
  };

  return (
    <Fragment>
      {props.mask ? renderWithMask() : renderWithoutMask()}
    </Fragment>
  )
}

export default Input;
